import React from 'react'
import { connect } from 'react-redux'
import documentSchema from "../../../forms/documentSchema";
import SchemaForm from "../../forms/SchemaForm";


class UploadDocumentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {text: '' ,template:''}
  }

  render() {
    return( <SchemaForm entityName='document' {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    uiSchema: documentSchema(state, ownProps),
  }
}

UploadDocumentForm.defaultProps = {
  submitButton: true
}
export default ( connect(mapStateToProps)(UploadDocumentForm));



